module.exports = __webpack_public_path__ + "sflyssofe.088c0693d1.svg";